'use client';

import React, { useState } from 'react';
import BrandLabHero from './BrandLabHero';
import MobileBrandLabHero from './MobileBrandLabHero';
import ServicesGrid from './ServicesGrid';
import SuccessMetrics from './SuccessMetrics';
import MobileSuccessMetrics from './MobileSuccessMetrics';
import InteractiveTools from './InteractiveTools';
import MobileInteractiveTools from './MobileInteractiveTools';
import ExpertiseShowcase from './ExpertiseShowcase';
import ProcessTimeline from './ProcessTimeline';
import ConsultationModal from './ConsultationModal';
import CTASection from './CTASection';

const BrandVisibilityLabInteractive = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleBookConsultation = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className="block lg:hidden">
                <MobileBrandLabHero />
            </div>
            <div className="hidden lg:block">
                <BrandLabHero />
            </div>
            <ExpertiseShowcase onBookConsultation={handleBookConsultation} />
            <ProcessTimeline onBookConsultation={handleBookConsultation} />
            <ServicesGrid />
            <div className="block lg:hidden">
                <MobileSuccessMetrics />
            </div>
            <div className="hidden lg:block">
                <SuccessMetrics />
            </div>
            <div className="block lg:hidden">
                <MobileInteractiveTools />
            </div>
            <div className="hidden lg:block">
                <InteractiveTools />
            </div>
            <CTASection onBookConsultation={handleBookConsultation} />
            <ConsultationModal isOpen={isModalOpen} onClose={handleCloseModal} />
        </>
    );
};

export default BrandVisibilityLabInteractive;